import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { DEFAULT_USER, IS_DEMO } from 'config.js';
import { messages } from 'lang/messages/messages';
import { actions } from 'react-table';

const initialState = {
    transactionList: {},
};

const TransactionListSlice = createSlice({
    name: 'transactionadminlist',
    initialState,
    reducers: {
        setTransactionList(state, action) {
            state.transactionList = action.payload;
        },
        // setToast(state, action) {
        //     state.preqcNotification = action.payload;
        // },
        // setToast(state, action) {
        //     state.notification = action.payload;
        // },

    },
});



export const TransactionListApi = (tokendata, page, limit, search) => async (dispatch) => {

    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/admin/paymentList?page=${page}&limit=${limit}&search=${search}`,
        {
            headers: {
                "authorization": ` Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "fsdfff")
            dispatch(setTransactionList(res?.data?.data))
            // dispatch(setToast({
            //     status: true, message: res?.data?.message
            // }))


        })
        .catch((err) => {
            console.log(err?.response, "wddss");


        })

}


export const { setTransactionList } = TransactionListSlice.actions;
const TransactionListReducer = TransactionListSlice.reducer;

export default TransactionListReducer;
